import { render } from "./MerchantBasket.vue?vue&type=template&id=694f2589&scoped=true"
import script from "./MerchantBasket.vue?vue&type=script&lang=js"
export * from "./MerchantBasket.vue?vue&type=script&lang=js"

import "./MerchantBasket.vue?vue&type=style&index=0&id=694f2589&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.33_vue@3.5.33_webpack@5.89.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-694f2589"]])

export default __exports__